import { apiClient, unwrapApiResult } from '@/lib/openapi-client';
import type { PaginatedResponse } from '@/types/api';
import type {
  AgencyStaffRead,
  ChangePasswordRequest,
  SelfUserUpdate,
  SetPasswordRequest,
  UserRead,
  UserRole,
  UserUpdate,
} from '@/types/generated';

export interface ListUsersParams {
  organization_id: number;
  limit?: number;
  offset?: number;
  search?: string;
  role?: UserRole;
}

export const usersApi = {
  list: (params: ListUsersParams): Promise<PaginatedResponse<UserRead>> =>
    unwrapApiResult(
      apiClient.GET('/api/v1/users/', { params: { query: params } }),
    ),
  agencyStaff: (organizationId: number): Promise<AgencyStaffRead> =>
    unwrapApiResult(
      apiClient.GET('/api/v1/users/agency-staff', {
        params: { query: { organization_id: organizationId } },
      }),
    ),
  update: (userId: number, data: UserUpdate): Promise<UserRead> =>
    unwrapApiResult(
      apiClient.PATCH('/api/v1/users/{user_id}', {
        params: { path: { user_id: userId } },
        body: data,
      }),
    ),
  remove: async (userId: number): Promise<void> => {
    await unwrapApiResult(
      apiClient.DELETE('/api/v1/users/{user_id}', {
        params: { path: { user_id: userId } },
      }),
    );
  },
  updateSelf: (data: SelfUserUpdate): Promise<UserRead> =>
    unwrapApiResult(apiClient.PATCH('/api/v1/users/me', { body: data })),
  setPassword: async (data: SetPasswordRequest): Promise<void> => {
    await unwrapApiResult(
      apiClient.POST('/api/v1/users/me/password', { body: data }),
    );
  },
  changePassword: async (data: ChangePasswordRequest): Promise<void> => {
    await unwrapApiResult(
      apiClient.POST('/api/v1/users/me/password/change', { body: data }),
    );
  },
  completeOnboarding: (): Promise<UserRead> =>
    unwrapApiResult(apiClient.POST('/api/v1/users/complete-onboarding')),
  completePortfolioTour: (): Promise<UserRead> =>
    unwrapApiResult(apiClient.POST('/api/v1/users/complete-portfolio-tour')),
} as const;
